var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Header'),(_vm.currentRoute === '/')?_c('div',[_c('Dashboard')],1):_vm._e(),(_vm.currentRoute === '/share')?_c('div',[_c('Shareboard')],1):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }